export async function enableMocking() {
    if (!process.env.USE_MSW_MOCK || process.env.ENV === 'production') {
        return;
    }

    const { worker } = await import('./browser');

    return worker.start({
        onUnhandledRequest: 'bypass'
    });
}
